import { Edit, Toggle } from "@monsterindia/global-ui-components";
import React, { useState } from "react";

import { AutoApplyIcon } from "./AutoApplyIcon";

type PreferenceItem = { text?: string; value?: string; name?: string };

export type ResumeAutoApplyNudgeProps = {
  preferredTitle?: PreferenceItem[];
  preferredLocations?: PreferenceItem[];
  skills?: PreferenceItem[];
  enabled?: boolean;
  onToggle?: (enabled: boolean) => void;
  onEdit?: () => void;
};

const toText = (items?: PreferenceItem[]) =>
  (items ?? [])
    .map((item) => item.text ?? item.value ?? item.name ?? "")
    .join(", ");

export const ResumeAutoApplyNudge: React.FC<ResumeAutoApplyNudgeProps> = ({
  preferredTitle,
  preferredLocations,
  skills,
  enabled: controlledEnabled,
  onToggle,
  onEdit,
}) => {
  const [internalEnabled, setInternalEnabled] = useState(false);
  const isChecked = internalEnabled;

  const handleToggle = (checked: boolean) => {
    setInternalEnabled(checked);
    onToggle?.(checked);
  };

  const titleText = toText(preferredTitle);
  const locationText = toText(preferredLocations);
  const skillsText = toText(skills);

  return (
    <div className="l1-autoApplyNudge">
      <div className="l1-autoApplyNudge__top">
        <AutoApplyIcon size={20} />
        <div className="l1-autoApplyNudge__content">
          <div className="l1-autoApplyNudge__header">
            <h3 className="l1-autoApplyNudge__title">Activate AI Auto Apply</h3>
            <span className="l1-autoApplyNudge__badge">
              Free for limited period
            </span>
          </div>

          <p className="l1-autoApplyNudge__desc">
            Let our Ai agent will apply for top jobs which most relevant based
            on your profile
          </p>
        </div>
        <div className="l1-autoApplyNudge__toggle">
          <Toggle
            toggleSize="small"
            checked={isChecked}
            onChange={(
              value: boolean | React.ChangeEvent<HTMLInputElement>,
            ) => {
              const nextVal =
                typeof value === "boolean" ? value : value.target.checked;
              handleToggle(nextVal);
            }}
            value="auto-apply-resume-nudge"
          />
        </div>
      </div>

      {isChecked && (
        <>
          <div className="l1-autoApplyNudge__preferences">
            <div className="l1-autoApplyNudge__prefsHeader">
              <h4 className="l1-autoApplyNudge__prefsTitle">Preferences</h4>
              <button
                type="button"
                className="l1-autoApplyNudge__editBtn"
                onClick={onEdit}
                aria-label="Edit preferences"
              >
                <Edit width={16} height={16} />
              </button>
            </div>
            <div className="l1-autoApplyNudge__prefsList">
              <div className="l1-autoApplyNudge__prefsRow">
                <span className="l1-autoApplyNudge__prefsLabel">
                  Preferred title:
                </span>
                <span
                  className="l1-autoApplyNudge__prefsValue"
                  title={titleText || "-"}
                >
                  {titleText || "-"}
                </span>
              </div>
              <div className="l1-autoApplyNudge__prefsRow">
                <span className="l1-autoApplyNudge__prefsLabel">
                  Preferred location:
                </span>
                <span
                  className="l1-autoApplyNudge__prefsValue"
                  title={locationText || "-"}
                >
                  {locationText || "-"}
                </span>
              </div>
              <div className="l1-autoApplyNudge__prefsRow">
                <span className="l1-autoApplyNudge__prefsLabel">Skills:</span>
                <span
                  className="l1-autoApplyNudge__prefsValue"
                  title={skillsText || "-"}
                >
                  {skillsText || "-"}
                </span>
              </div>
            </div>
          </div>
          <p className="l1-autoApplyNudge__note">
            Note: You can deactivate this feature from &quot;Settings&quot;
          </p>
        </>
      )}
    </div>
  );
};
